export function formOverlay() {
    const overlay = document.querySelector('.form-overlay');
    if (!overlay) return;

    const triggers = document.querySelectorAll('a[href="#form-trigger"]');
    const closeButton = document.querySelector('.form-overlay .close-button');
    const isOpen = () => overlay.classList.contains('is-open');

    const open = () => {
        overlay.classList.remove('invisible', 'opacity-0');
        overlay.classList.add('visible', 'opacity-100', 'is-open');
        document.body.style.overflow = 'hidden';
    };

    const close = () => {
        overlay.classList.remove('visible', 'opacity-100', 'is-open');
        overlay.classList.add('invisible', 'opacity-0');
        document.body.style.overflow = '';
    };

    const toggle = () => {
        if (isOpen()) {
            close();
        } else {
            open();
        }
    };

    triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            toggle();
        });
    });

    closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        toggle();
    });

    overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
            close();
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isOpen()) {
            close();
        }
    });
}
